<template>
  <div>
    <div class="page-wrapper" >
      <Header @clicked="sidebar_toggle" @mobileclicked="mobiletoggle_toggle" />
      <div class="page-body-wrapper" >
        <div class="page-body">
          <Breadcrumbs />          
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12">
                <b-tabs style="margin-bottom:20px;">
                  <b-tab title="Home" :active="this.$router.history.current.fullPath == '/admin/dashboard'" @click="route('/admin/dashboard')">
                    <template slot="title">
                        <feather type="home"></feather>
                        <span class="infra-icon-desc infra-blue">Home</span>
                    </template>
                  </b-tab>
                  <b-tab title="Bauprojekte"  :active="this.$router.history.current.fullPath.indexOf('bauprojekt') > -1" @click="route('/admin/dashboard/bauprojekte')">
                    <template slot="title">
                        <feather type="layers"></feather>
                        <span class="infra-icon-desc infra-blue">Bauprojekte</span>
                    </template>
                  </b-tab>
                  <b-tab title="Kunden" :active="this.$router.history.current.fullPath.indexOf('kunde') > -1" @click="route('/admin/dashboard/kunden')">
                    <template slot="title">
                        <feather type="users"></feather>
                        <span class="infra-icon-desc infra-blue">Kunden</span>
                    </template>
                  </b-tab>
                  <b-tab title="Dienstleister" :active="this.$router.history.current.fullPath.indexOf('dienstleister') > -1" @click="route('/admin/dashboard/dienstleister')">
                    <template slot="title">
                      <feather type="tool"></feather>
                      <span class="infra-icon-desc infra-blue">Dienstleister</span>
                    </template>
                  </b-tab>
                  <b-tab title="Nachrichten" :active="this.$router.history.current.fullPath.indexOf('nachricht') > -1" @click="route('/admin/dashboard/nachrichten')" >
                    <template slot="title">                      
                      <feather type="inbox"></feather>
                      <span v-if="unseen"> {{unseen}} &nbsp;</span>                      
                      <span class="infra-icon-desc infra-blue">Nachrichten</span>
                    </template>
                  </b-tab>
                  <b-tab :active="this.$router.history.current.fullPath.indexOf('meldung') > -1" @click="route('/admin/dashboard/meldungen')">
                    <template slot="title">
                      <feather type="info"></feather>
                      <span class="infra-icon-desc infra-blue">Meldungen</span>
                    </template>
                  </b-tab>
                  <b-tab title="Benutzer" :active="this.$router.history.current.fullPath.indexOf('benutzer') > -1" @click="route('/admin/dashboard/benutzer')">
                    <template slot="title">
                      <feather type="users"></feather>
                      <span class="infra-icon-desc">Benutzer</span>
                    </template>
                  </b-tab>

                  <b-tab title="Hilfe" :active="this.$router.history.current.fullPath.indexOf('hilfe') > -1" @click="route('/admin/dashboard/hilfe')">
                    <template slot="title">
                      <feather type="help-circle"></feather>
                      <span class="infra-icon-desc">Hilfe</span>
                    </template>
                  </b-tab>
                </b-tabs>
                <transition
                  :name="animations.standard.name"
                  :enter-active-class="animations.standard.enter"
                  :leave-active-class="animations.standard.leave"
                  mode="out-in"
                >
                  <router-view></router-view>
                </transition>
              </div>
            </div>
          </div>          
        </div>
        <Footer />
      </div>      
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Header from "./header";
import Footer from "./footer";

export default {
  name: "mainpage",
  data() {
    return {
      mobileheader_toggle_var: false,
      sidebar_toggle_var: false,
      resized: false,
      currentTab: "/admin/dashboard"
    };
  },
  // props:['sidebar_toggle_var'],
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout,
    }),
    ...mapGetters({
      animations: "app/animations",
      unseen: "chat/unseenMessages"

    })
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.resized = this.sidebar_toggle_var;

  },
  watch: {
    $route() {
      this.menuItems.filter(items => {
        if (items.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", items);
        if (!items.children) return false;
        items.children.filter(subItems => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subItems);
          if (!subItems.children) return false;
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch("menu/setActiveRoute", subSubItems);
          });
        });
      });
    },
    sidebar_toggle_var: function() {
      this.resized =
        this.width <= 991 ? !this.sidebar_toggle_var : this.sidebar_toggle_var;
    }
  },
  methods: {
    sidebar_toggle(value) {
      this.sidebar_toggle_var = !value;
    },
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value;
    },
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    route(destination) {
      this.$router.push(destination);
      this.currentTab = destination;
    },
    debug() {
      console.log(this.unseen);
    }
  }
};
</script>

<style>
.unseen {
  background:blue;
  color:white;
}
</style>
